module.exports = __webpack_public_path__ + "img/404-illustration.e2391633.svg";